export type NavLinkMatch = {
  path: string
  /** Extra path prefixes that belong to this tab, e.g. pages reached only from inside it. */
  alsoActiveOn?: string[]
}

const isWithin = (pathname: string, prefix: string) =>
  pathname === prefix || pathname.startsWith(`${prefix}/`)

/**
 * The nav tab for the current page: the one whose path is the longest segment-wise prefix of it,
 * so /translations/glossary/1 lights 용어집 rather than 번역, and a detail page such as
 * /orders/1 still lights its list's tab.
 */
export const getActiveNavPath = (
  pathname: string,
  links: NavLinkMatch[]
): string | undefined => {
  let active: { path: string; length: number } | undefined
  for (const link of links) {
    for (const prefix of [link.path, ...(link.alsoActiveOn ?? [])]) {
      if (isWithin(pathname, prefix) && (!active || prefix.length > active.length)) {
        active = { path: link.path, length: prefix.length }
      }
    }
  }
  return active?.path
}
